import App from "./experience/app";

const app = App.Instance;
